import React from "react";
import { Container, Row, Col, Card, CardBody, Table, Badge, Button } from "reactstrap";

const Attendance = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3 align-items-center">
          <Col>
            <h4 className="card-title">Attendance & Shift Logs</h4>
            <p className="card-title-desc mb-0">Track employee daily check-in, check-out, and working hours.</p>
          </Col>
          <Col className="text-end">
            <Button color="primary" className="btn-rounded">
              <i className="mdi mdi-clock-in me-1"></i> Mark Today's Attendance
            </Button>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table-centered table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Date</th>
                        <th>Employee</th>
                        <th>Department</th>
                        <th>Check In</th>
                        <th>Check Out</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan="6" className="text-center py-4 text-muted">
                          No attendance records found for today.
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Attendance;
